import { useEffect, useState } from 'react'
import jitterTime from 'jitter-time'
import {
  useRegisterManager,
  useTrainingModeManager,
} from '../../ng-compat/hooks'
import { useIsOffline } from '../shared/useIsOffline'

export const useRegisterOpenReminderNeeded = () => {
  const registerManager = useRegisterManager()
  const trainingModeManager = useTrainingModeManager()
  const offline = useIsOffline()

  const [trainingModeEnabled, setTrainingModeEnabled] = useState(
    trainingModeManager.trainingModeEnabled
  )
  const [needed, setNeeded] = useState(
    registerManager.isRegisterOpenReminderNeeded()
  )

  useEffect(() => {
    const setEnabled = () =>
      setTrainingModeEnabled(trainingModeManager.trainingModeEnabled)

    trainingModeManager.on('trainingModeEnabledChange', setEnabled)

    return () => {
      trainingModeManager.off('trainingModeEnabledChange', setEnabled)
    }
  }, [trainingModeManager])

  useEffect(() => {
    if (offline || trainingModeEnabled) {
      setNeeded(false)
    }

    const checkIfNeeded = () =>
      setNeeded(registerManager.isRegisterOpenReminderNeeded())

    checkIfNeeded()

    const interval = setInterval(checkIfNeeded, jitterTime(5))
    return () => clearInterval(interval)
  }, [offline, trainingModeEnabled, registerManager])

  return needed
}
